import { fetchData } from '@/utils/fetch'

export const retrieveFavoriteProductList = async (data, options) => {
  return fetchData('/appb/b2b/collect/products', {
    method: 'post',
    body: JSON.stringify(data),
    ...options
  })
}

export const retrieveFavoriteFactoryList = async (data, options) => {
  return fetchData('/appb/b2b/collect/suppliers', {
    method: 'post',
    body: JSON.stringify(data),
    ...options
  })
}

export const removeFavorite = async (data) => {
  return fetchData('/appb/b2b/collect/remove', {
    method: 'post',
    body: JSON.stringify(data)
  })
}

export const addFavorite = async (data) => {
  return fetchData('/appb/b2b/collect/save', {
    method: 'post',
    body: JSON.stringify(data)
  })
}
